import api from './api';

export const kontakService = {
    // PUBLIC: Kirim pesan kontak
    sendKontak: async (data) => {
        try {
            const response = await api.post('/kontak', data);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengirim pesan',
                errors: error.response?.data?.errors,
            };
        }
    },

    // ADMIN: Get list
    getList: async (params = {}) => {
        try {
            const response = await api.get('/kontak-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    // ADMIN: Get detail
    getDetail: async (id) => {
        try {
            const response = await api.get(`/kontak-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    // ADMIN: Update status
    updateStatus: async (id, status, catatan_admin = null) => {
        try {
            const response = await api.post(`/kontak-admin/${id}/status`, {
                status,
                catatan_admin,
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },

    // ADMIN: Delete
    delete: async (id) => {
        try {
            const response = await api.delete(`/kontak-admin/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    // ADMIN: Statistics
    getStatistics: async () => {
        try {
            const response = await api.get('/kontak-statistics');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil statistik' };
        }
    },
};

export default kontakService;